import { useNavigate } from 'react-router-dom';

import { ReactComponent as EditIcon } from '../../assets/icons/editIcon.svg';
import { Button, Typography } from '../../designComponents';
import {
  ButtonContainer,
  SimpleSmartContainerStyled,
  WrapperStyled,
} from './landing-styles';

type Props = {};

const SimpleSmart = (_props: Props) => {
  const navigate = useNavigate();
  return (
    <SimpleSmartContainerStyled>
      <WrapperStyled>
        <Typography className="title" strong>
          Simple, smart, stunning diagrams for every buildings.
        </Typography>
        <Typography
          size={20}
          style={{ textAlign: 'center', color: '#333333', fontWeight: '600' }}
        >
          EscapePlan revolutionized the way we handle emergency preparedness in
          our building. The ease of use and comprehensive templates made
          creating our escape plan a breeze.
        </Typography>
        <ButtonContainer>
          <Button
            style={{ borderRadius: '28px', padding: '6px 16px' }}
            onClick={() => navigate('/login')}
          >
            Sign In Today
          </Button>
          <Button
            style={{
              borderRadius: '28px',
              padding: '6px 16px',
              background: 'white',
              color: 'green',
            }}
          >
            <EditIcon />
            Create Building
          </Button>
        </ButtonContainer>
      </WrapperStyled>
    </SimpleSmartContainerStyled>
  );
};

export default SimpleSmart;
